import {
    useRef
} from 'react';

import { SimpleGrid } from '@mantine/core';

import { useInvoices } from '../hooks/useInvoices';
import { useInvoicesSelection } from '../hooks/useInvoicesSelection';
import { useTableColumns } from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";

export const RecordsTable = () => {
    const { columns } = useTableColumns('customer');

    const {
        items,
        loading,
        totalCount,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useInvoices();

    const { selectedRecords, setSelectedRecords } = useInvoicesSelection();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};
